import Swiper, { Navigation, Thumbs, EffectFade, Zoom } from 'swiper';
import { getOptionsFromJsonString } from "../../../default/global/js/utilities/options";
import { isTouchDevice } from "../../../default/global/js/touchDevice";
import { init360Images } from "../../../default/global/js/init360Images";

Swiper.use([Navigation, Thumbs, EffectFade, Zoom]);

let lastMoveTime = 0; // Globale Variable für FPS-Limit

function buildItemcardMainSwiper(el, options = {}, swiperThumbs = false, initialized = () => {}) {
    Swiper.use([EffectFade, Zoom]);

    // Sicherstellen, dass die Zoom-Container korrekt sind
    el.querySelectorAll('.swiper-slide img').forEach(img => {
        let zoomContainer = document.createElement('div');
        zoomContainer.classList.add('swiper-zoom-container');
        img.parentNode.insertBefore(zoomContainer, img);
        zoomContainer.appendChild(img);
        img.setAttribute('data-swiper-zoom', '1.3'); // Zoom-Faktor setzen
    });

    let swiperMainImages = new Swiper(el, {
        speed: options.eff_interval,
        loop: true,
        effect: 'fade',
        items: 1,
        allowTouchMove: isTouchDevice(),
        zoom: {
            maxRatio: 1.3,
            toggle: false,
            panOnMouseMove: true
        },
        thumbs: {
            swiper: swiperThumbs
        },
        on: {
            init: function () {
                initialized();
            },
            slideChange: function () {
                const activeSlide = this.slides[this.activeIndex];
                if (activeSlide) {
                    init360Images(activeSlide.querySelectorAll('.js-load360'));
                }
            }
        },
    });

    el.addEventListener("mouseenter", () => {
        swiperMainImages.zoom.in();
    });

    el.addEventListener("touchstart", (event) => {
        swiperMainImages.zoom.in();
        document.body.style.overflow = 'hidden';
    });

    el.addEventListener("mousemove", (event) => {
        handleZoomMove(event, el, swiperMainImages);
    });

    el.addEventListener("touchmove", (event) => {
        handleZoomMove(event.touches[0], el, swiperMainImages);
        event.preventDefault();
    }, { passive: false });

    el.addEventListener("mouseleave", () => {
        swiperMainImages.zoom.out();
    });

    el.addEventListener("touchend", () => {
        swiperMainImages.zoom.out();
        document.body.style.overflow = '';
    });

    return swiperMainImages;
}

function handleZoomMove(event, el, swiperMainImages) {
    const now = performance.now();
    if (now - lastMoveTime < 16) return; // FPS-Limit für bessere Performance
    lastMoveTime = now;

    if (!swiperMainImages.zoom.scale || swiperMainImages.zoom.scale === 1) return; // Falls nicht gezoomt, keine Bewegung

    const slide = el.querySelector(".swiper-slide-active .swiper-zoom-container");
    if (slide) {
        const rect = slide.getBoundingClientRect();
        const offsetX = (event.clientX - rect.left) / rect.width;
        const offsetY = (event.clientY - rect.top) / rect.height;

        let translateX = -(offsetX - 0.5) * 100;
        let translateY = -(offsetY - 0.5) * 100;

        const maxTranslate = 25;
        translateX = Math.max(-maxTranslate, Math.min(maxTranslate, translateX));
        translateY = Math.max(-maxTranslate, Math.min(maxTranslate, translateY));

        slide.style.transition = "transform 0.2s ease-out";
        slide.style.transform = `scale(${swiperMainImages.zoom.scale}) translate(${translateX}%, ${translateY}%)`;
    }
}

function buildItemcardThumbsSwiper(el, options = {}, swiperMain) {
    let btnPrev = document.createElement("div");
    btnPrev.classList.add('swiper-button-prev-itemcard', 'swiper-button-prev');
    btnPrev.innerHTML = "<i class='icon icon-angle-left'></i>";

    let btnNext = document.createElement("div");
    btnNext.classList.add('swiper-button-next-itemcard', 'swiper-button-next');
    btnNext.innerHTML = "<i class='icon icon-angle-right'></i>";

    el.parentElement.parentElement.appendChild(btnPrev);
    el.parentElement.parentElement.appendChild(btnNext);

    let swiperThumbsImages = new Swiper(el, {
        speed: options.eff_interval,
        direction: options.directionThumbs === "vertical" && window.outerWidth > options.directionBreakpoint ? 'vertical' : 'horizontal',
        slidesPerView: options.slidesPerViewThumbs,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        allowTouchMove: true,
        touchRatio: 1,
        spaceBetween: options.spaceBetweenThumbs,
        navigation: {
            nextEl: '.swiper-button-next-itemcard',
            prevEl: '.swiper-button-prev-itemcard',
        }
    });
    return swiperThumbsImages;
}

export function initItemcardImages() {
    const wrapper = document.querySelector('.js-itemcardImages');
    if (wrapper) {
        const mainImages = wrapper.querySelector('.js-itemcardImagesMain');
        const thumbsImages = wrapper.querySelector('.js-itemcardImagesThumbs');
        let swiperThumbs = false;

        let options = getOptionsFromJsonString(wrapper.getAttribute('data-options'), {
            eff_interval: 300,
            directionThumbs: "horizontal",
            directionBreakpoint: GLOBALS.gridBreakpoints.sm - 1,
            slidesPerViewThumbs: 5,
            spaceBetweenThumbs: 20
        });

        if (wrapper.classList.contains('thumbsLeft')) {
            options.directionThumbs = "vertical";
        }

        if (mainImages) {
            wrapper.classList.add("is-loading");
            if (thumbsImages) {
                swiperThumbs = buildItemcardThumbsSwiper(thumbsImages, options, mainImages);
            } else {
                console.error('Thumbs Images not found');
            }
            buildItemcardMainSwiper(mainImages, options, swiperThumbs, function () {
                setTimeout(function () {
                    wrapper.classList.remove("is-loading");
                    wrapper.classList.add("initialized");
                }, 200);
            });
        } else {
            console.error('Main Images not found');
        }
    }
}
